/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Token_WarningInputs */



/**
* | output |
* | --- |
* | "This token will only be shown once. Make sure to copy it now and store it securely." |
*
* @param {Scim_Token_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_token_warning = /** @type {((inputs?: Scim_Token_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Token_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Token wird nur einmal angezeigt. Stellen Sie sicher, dass Sie es jetzt kopieren und sicher speichern.")
	return /** @type {LocalizedString} */ ("This token will only be shown once. Make sure to copy it now and store it securely.")
});